import React, { useEffect, useState } from 'react';
import { TaskSection } from 'components/common/TaskSection';
import { Box } from '@mui/material';
import { useProcurementOrderOperations, useToggleModal } from '@hooks';
import { ModalV2 } from 'components/common/modals';
import { ButtonV2 } from 'components/common/ui';
import { useFormContext } from 'react-hook-form';
import { useRouter } from 'next/router';
import { procurementServices } from '@services';
import { showError } from '@utils';
import AddVehiclesForm from './AddVehiclesForm';

import formStyles from '../ProcurementOrderForm/procurementOrderForm.style';
import styles from './procurementOrderContent.style';

const IndividualVehicleDetails = ({ index }) => {
  const [loading, setLoading] = useState(false);
  const { isOpen, handleClose, handleOpen } = useToggleModal();
  const methods = useFormContext();
  const router = useRouter();

  const { getProcurementOrder } = useProcurementOrderOperations();

  const totalVehicles = methods.watch(`skuGroups.${index}.totalVehicles`);
  const totalPrice = methods.watch(`skuGroups.${index}.totalPrice.number`);
  const isLocal = methods.watch(`skuGroups.${index}.isLocal`);
  const skuGroupId = methods.watch(`skuGroups.${index}.vehicleDetails.skuId`);
  const orderInternalId = methods.watch(`internalId`);
  const procurementOrderId = router.query?.procurementOrderId;

  const skuGroupRoute = {
    pathname: '/procurement/[procurementOrderId]/[skuGroupId]',
    query: {
      procurementOrderId,
      skuGroupId,
      orderId: orderInternalId,
    },
  };

  useEffect(() => {
    if (
      router.isReady &&
      procurementOrderId &&
      skuGroupId &&
      orderInternalId &&
      !isLocal
    ) {
      router.prefetch(skuGroupRoute);
    }
  }, [router, procurementOrderId, skuGroupId, orderInternalId, isLocal]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleViewAll = () => {
    router.push(skuGroupRoute);
  };

  const actionsRender = () => {
    return (
      <Box sx={styles.vehicleDetailsActions}>
        <ButtonV2
          variant="outlined"
          color="primary"
          onClick={handleOpen}
          size="small"
          disabled={isLocal}
        >
          Add Vehicles
        </ButtonV2>
        <ButtonV2
          color="primary"
          onClick={handleViewAll}
          size="small"
          disabled={isLocal || !totalVehicles}
        >
          View all
        </ButtonV2>
      </Box>
    );
  };

  const handleSubmit = async (value) => {
    try {
      setLoading(true);
      await procurementServices.updateSkuGroup(
        router.query.procurementOrderId,
        skuGroupId,
        {
          quantity: Number(value?.quantity),
        }
      );
      await getProcurementOrder();
      handleClose();
    } catch (error) {
      showError(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <TaskSection
        title="Individual Vehicle Details"
        action={actionsRender()}
        isEmbedded
      >
        <Box sx={styles.row}>
          <Box sx={styles.title}>Number of Vehicles</Box>
          <Box sx={formStyles.vehiclesNumber}>{totalVehicles || 0}</Box>
        </Box>
        <Box sx={{ ...styles.row, marginTop: '30px' }}>
          <Box sx={styles.title}>Total Price for SKU Group</Box>
          <Box sx={formStyles.secondaryText}>{totalPrice || 0}€</Box>
        </Box>
      </TaskSection>
      {isOpen && (
        <ModalV2
          id="add-vehicles-modal"
          title="Add Sku Group Vehicles"
          isOpen={isOpen}
          onClose={handleClose}
          size="xs"
          maxWidth="xs"
          isLoading={loading}
        >
          <AddVehiclesForm
            loading={loading}
            onSubmit={handleSubmit}
            onCancel={handleClose}
          />
        </ModalV2>
      )}
    </>
  );
};

export default IndividualVehicleDetails;
